import { render } from "./Statements.vue?vue&type=template&id=4b21975e&scoped=true&ts=true"
import script from "./Statements.vue?vue&type=script&lang=ts"
export * from "./Statements.vue?vue&type=script&lang=ts"

import "./Statements.vue?vue&type=style&index=0&id=4b21975e&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b21975e"]])

export default __exports__